subscribe("cart-update", (data) => {
  insuranceCalc();
  freeGift();
  wholesaleMins();
});
subscribe("cart-drawer-open", () => {
    console.log("in cart drawer open");
  wholesaleMins();
});

const myButton = document.getElementById('cart-icon-bubble');
myButton.addEventListener('click', (event) => {
    wholesaleMins();
});
if(window.location.pathname == "/cart"){
    wholesaleMins();
    insuranceCalc();
    freeGift();
}
function wholesaleMins(){
    let customerTags = window.freeGiftSettings.customerTags;
    if(customerTags.includes("wholesale")){
        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
            let openingMin = window.wholesaleSettings.openingMin * 100;
            let subsequentMin = window.wholesaleSettings.subsequentMin * 100;
            let numOrders = window.wholesaleSettings.numOrders * 1;
            let minMet = false;
            let message = "";
            if(numOrders == 0){
                if(cart.total_price >= openingMin)
                {
                    minMet = true;
                }
                else{
                    message = "Your opening order must be at least $500 after discount."
                }
            }
            else{
                if(cart.total_price >= subsequentMin)
                {
                    minMet = true;
                }
                else{
                    message = "Your order must be at least $300 after discount."
                }
            }
            if(minMet){
                if(window.location.pathname == "/cart"){
                    const myItems = document.querySelectorAll(".cart__checkout");
                    myItems[0].style.display = "inline-flex";
                    myItems[0].disabled = false;
                    const myItems2 = document.querySelectorAll(".wt-cart__subtitle__tax");
                    myItems2[0].innerHTML = "";
                }
                else{
                const myItems = document.querySelectorAll(".btn-checkout");
                myItems[0].style.display = "inline-flex";
                myItems[0].disabled = false;
                const myItems2 = document.querySelectorAll(".wt-cart__subtitle__text");
                myItems2[0].innerHTML = "";
                }
            }
            else{
                if(window.location.pathname == "/cart"){
                    const myItems = document.querySelectorAll(".cart__checkout");
                    myItems[0].style.display = "none";
                    myItems[0].disabled = true;
                    const myItems2 = document.querySelectorAll(".wt-cart__subtitle__tax");
                    myItems2[0].style.backgroundColor = "red";
                    myItems2[0].style.color = "white";
                    myItems2[0].innerHTML = message;
                    document.querySelectorAll(".cart__dynamic-checkout-buttons")[0].style.display = "none";
                }
                else{
                    const myItems = document.querySelectorAll(".btn-checkout");
                    myItems[0].style.display = "none";
                    myItems[0].disabled = true;
                    const myItems2 = document.querySelectorAll(".wt-cart__subtitle__text");
                    myItems2[0].style.backgroundColor = "red";
                    myItems2[0].style.color = "white";
                    myItems2[0].innerHTML = message;
                }
            }
            if(window.wholesaleSettings.wPTags.includes("retail-only")){
                message = "Your cart contains one or more items that are retail only, and, you are logged in as a wholesaler.";
                if(window.location.pathname == "/cart"){
                    const myItems = document.querySelectorAll(".cart__checkout");
                    myItems[0].style.display = "none";
                    myItems[0].disabled = true;
                    const myItems2 = document.querySelectorAll(".wt-cart__subtitle__tax");
                    myItems2[0].style.backgroundColor = "red";
                    myItems2[0].style.color = "white";
                    myItems2[0].innerHTML = message;
                    document.querySelectorAll(".cart__dynamic-checkout-buttons")[0].style.display = "none";
                }
                else{
                    const myItems = document.querySelectorAll(".btn-checkout");
                    myItems[0].style.display = "none";
                    myItems[0].disabled = true;
                    const myItems2 = document.querySelectorAll(".wt-cart__subtitle__text");
                    myItems2[0].style.backgroundColor = "red";
                    myItems2[0].style.color = "white";
                    myItems2[0].innerHTML = message;
                }
            }
        })
    }
}
function insuranceSet(){
  var attributes = {};
  if(!document.querySelector('[name="attributes[insurance]"]').checked){
                //customer has declined insurance
                attributes = {
                    "insurance": "false",
                    "decline-insurance": "declined"
                    }
            }
  else{
    //customer has accepted insurance
                attributes = {
                    "insurance": "true",
                    "decline-insurance": "not-declined"
                    }
  }
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ attributes: attributes })
                    })
                    .then(response => {
                      this.insuranceCalc();
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
}
function insuranceCalc(){
  fetch(window.Shopify.routes.root + 'products/package-protection.js')
  .then(response => response.json())
  .then(insurProduct => {
        var reCalc = false;
        var insurVar = 0;
        var reqVar = 0;
        var reqPrice = 0;
        var insurTotal = 0;
        var exemptInCart = 0;
        var insurPercent = 0.0275;
        var aItem;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
            for(aItem of cart.items){
                if(aItem.handle == "package-protection"){
                    insurTotal = aItem.original_line_price;
                    insurVar = aItem.variant_id;
                    reqVar = aItem.variant_id;
                    reqPrice = aItem.original_price;
                }
                else if(aItem.gift_card){
                    exemptInCart = exemptInCart + aItem.original_line_price;
                }
            }
            var calcTotal = Math.round((cart.total_price - exemptInCart - insurTotal)*insurPercent);
            var attributes = {};
            var updates = {};
            let customerTags = window.freeGiftSettings.customerTags;
            if(customerTags.includes("wholesale")){
                calcTotal = 0;
            }
            if(calcTotal == 0){
                //no cart contents require insurance, hide the div entirely
                attributes = {
                    "insurance": "false",
                    "decline-insurance": "not-declined"
                    }
            }
                          var v;
                for(v of insurProduct.variants){
                    if(v.price < calcTotal){
                    //do nothing, need to keep going to a higher variant
                    }
                    else{
                        if(insurVar != v.id){
                            reCalc = true;
                            reqVar = v.id;
                            reqPrice = v.price;
                        }
                        break;
                    }
                }
            try{
            document.getElementById("reqPrice").innerHTML = Shopify.formatMoney(reqPrice, window.Shopify.money_format);
            }
            catch(error){}
            let pChecked = false;
            try{
             pChecked = document.querySelector('[name="attributes[insurance]"]').checked
            }
            catch(error){
                calcTotal = 0;
            }
            if(!pChecked){
                //customer has declined insurance
                calcTotal = 0;
            }
            if(calcTotal == 0 && insurTotal > 0){
                //then there is insurance in the cart that shouldn't be, remove it
                updates = {};
                updates[insurVar] = 0;
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: updates, attributes: attributes })
                    })
                    .then(response => {
                    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
            }
            else if(calcTotal > 0)
            {
                //then the cart is eligible for insurance, check to see if right amount is applied
                if(reCalc){
                    //then current insurance amount in cart is not correct
                    updates = {};
                    updates[reqVar] = 1;
                    
                    if(insurVar != 0)
                    {
                        //insurance is currently in the cart, but not the correct amount, remove old
                        updates[insurVar] = 0;
                    }
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ updates: updates, attributes: attributes  })
                    })
                    .then(response => {
                        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                }
            }
        })
    });
}
function freeGift(){
if(window.freeGiftSettings.enableFreeGift){
    let customerTags = window.freeGiftSettings.customerTags;
    if(customerTags.includes("wholesale")){
        console.log("wholesale customer - no free gift!");
    }
    else{
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
            let giftThresh = window.freeGiftSettings.freeGiftThreshold * 100;
            let containsItem = false;
            let attr = {};
           console.log(cart);
           if(cart.total_price >= giftThresh){
            console.log("cart threshold met");
            for(aItem of cart.items){
                if(aItem.variant_id == window.freeGiftSettings.freeGiftProduct){
                    containsItem = true;
                    break;
                }
            }
            if(containsItem){
                console.log("cart already contains free gift item");
            }
            else{
                console.log("cart qualifies for free item but does not contain it, adding now");
                updates = {};
                updates[window.freeGiftSettings.freeGiftProduct] = 1;
                attr = {
                    "Free-Gift": "true"
                    };
                    console.log(attr);
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: updates, attributes: attr })
                    })
                    .then(response => {
                    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
            }
           }
           else{
            console.log("gift threshold not met");
           }
        })
    }
}
}